import { getCookie, setCookie } from "./cookie-handling";
jQuery(document).on('ready', function () {
    if (jQuery('#myContentInfoPopup').length > 0) {
        const popup = jQuery('#myContentInfoPopup');
        const closeIcon = popup.find('.wm-popup__myContentInfoInnerCloseIcon');
        const closeButton = popup.find('.wm-popup__myContentInfoInnerCloseButton');
        var cookieValue = getCookie('popupMyContentInfoShown');
        var splitTestPopupClosed = getCookie('randomPopupClosed');
        if (cookieValue !== 'true' && splitTestPopupClosed == 'true') {
            var scrollPosition = jQuery(window).scrollTop();
            var windowHeight = jQuery(window).height();
            jQuery(window).on('scroll', function () {
                scrollPosition = jQuery(window).scrollTop();
                if (scrollPosition >= windowHeight) {
                    popup.addClass('-show');
                }
            });
        }
        closeIcon.on('click', function () {
            setCookie('popupMyContentInfoShown', 'true', 90);
            popup.removeClass('-show');
            popup.addClass('-closed');
            cookieValue = 'true';
            console.log('cookie popupMyContentInfoShown set to true');
        });
        closeButton.on('click', function () {
            setCookie('popupMyContentInfoShown', 'true', 90);
            popup.removeClass('-show');
            popup.addClass('-closed');
            cookieValue = 'true';
            console.log('cookie popupMyContentInfoShown set to true');
        });
    }
});
